<template>
  <div class="box">
    <div id="container" :key="num"></div>
    <div class="pastureBack" v-if="loading">
      <div class="pasture" :key="loading">
        <div class="pasture-title">牧场详情 <span class="pasture-exit" @click="clickClose(item)"></span></div>

        <div class="iframes" v-show="divLoading">
          <div style="width: 560px; height: 320px; position: relative">
            <easyplayerVideo :camera="item" v-if="item.videoSrc"></easyplayerVideo>
            <div v-else style="width: 560px; height: 320px" v-html="item.html"></div>
          </div>
          <span v-if="item.deviceType" @click="playBack(item)" v-show="!item.videoSrc"></span>
        </div>
        <div class="iframes" v-show="!divLoading" style="width: 560px; height: 320px; position: relative; background: #000">
          <img :src="zcItemImg" alt="" style="width: 100%; height: 100%" />
        </div>
        <div style="display: flex; height: 188px; margin-top: 10px">
          <div class="pasture-box">
            <div :class="{ divAcive: divLoading }" @click="clickType(true)">实时画面</div>
            <div :class="{ divAcive: !divLoading }" style="margin-top: 15px" @click="clickType(false)" v-if="item.algorithmCount > 0">
              资产盘点
            </div>
          </div>
          <div v-if="divLoading" style="flex: 1">
            <div class="pasture-name">
              {{ item.farmName }}
              <p class="pasture-name-breed">羊</p>
            </div>
            <div class="pasture-address">
              <span class="pasture-icon"></span>
              {{ item.areaAddress }}
            </div>
            <div class="pasture-user">
              <p>联系人 :</p>
              <p class="pl8 white">
                {{ item.farmerUserName }}
              </p>
              <p class="pl20" style="color: #868686">|</p>
              <p class="pl20">电话 :</p>
              <p class="pl8 white">
                {{ item.farmerUserPhone }}
              </p>
            </div>
            <div class="pasture-data">
              <div>
                <p>总存栏数</p>
                <p class="pasture-number">
                  {{ item.livestockCount }}
                  <span>头</span>
                </p>
              </div>
            </div>
          </div>
          <div v-if="!divLoading" class="ssets">
            <div>
              <el-date-picker
                value-format="yyyy-MM-dd"
                @change="changezcpd"
                v-model="checkInfo.createTime"
                type="date"
                placeholder="选择时间"
                style="width: 170px; height: 30px; position: relative"
                :key="num"
                :append-to-body="false"
                @focus="changeNum"
              ></el-date-picker>
            </div>
            <ul class="ssets-ul">
              <li v-for="(item, index) in checkList" :key="index" :class="index == zcIndex ? 'liActive' : ''" @click="zcClick(item, index)">
                <div style="flex: 1">
                  {{ item.createTime }}
                </div>
                <div style="width: 50px; text-align: right; padding-right: 10px">
                  {{ item.checkCount }}
                </div>
              </li>
            </ul>
          </div>
          <div v-if="!divLoading" class="ssets-count">最大盘点数：{{ zcCount }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 第三方地图
import AMapLoader from '@amap/amap-jsapi-loader';
window._AMapSecurityConfig = {
  securityJsCode: 'd125d6c38f37232e64d03bfb057dbbfc'
};

import 'video.js/dist/video-js.css';
import videojs from 'video.js';
import 'videojs-contrib-hls';
import 'video.js/dist/video-js.min.css';
import lang_zhcn from 'video.js/dist/lang/zh-CN.json';
videojs.addLanguage('zh-CN', lang_zhcn);

import { getFarmMapList } from '@/api/zzry';
import { getDeviceLiveAddress } from '@/api/device';

import easyplayerVideo from '@/components/easyplayerVideo.vue';

import { getNewUserDsList, getDeviceCheckCount, getUserDsList, findDictList, selectByAreas, selectListPAreasInfo } from '@/api/device';
import dayjs from 'dayjs';
export default {
  name: 'maps',
  data() {
    return {
      map: null,
      disCountry: null,
      mask: [],
      info: null,
      formList: null,
      markers: [],
      item: null,
      loading: false,
      openLoading: true,
      telecomUrl: '',
      videoOptions: {
        muted: false, // 设置了它为true，才可实现自动播放,同时视频也被静音 （Chrome66及以上版本，禁止音动播放）
        autoplay: true, // 设置自动播放
        controls: true,
        controlBar: { playToggle: false },
        language: 'zh-CN',
        liveui: true,
        notSupportedMessage: '视频地址失效',
        hls: {
          withCredentials: true
        }
      },
      videoIndex: 0,
      divLoading: true,
      zcpdDate: '',
      checkInfo: {
        createTime: dayjs(new Date()).format('YYYY-MM-DD'),
        deviceId: '',
        current: 1,
        size: 150
      },
      checkList: null,
      zcCount: null,
      zcItemImg: '',
      zcIndex: 0,
      num: 0,
      // 地图本地数据
      mapLocalData: {},
      districtMap: null
    };
  },
  components: { easyplayerVideo },
  mounted() {
    const that = this;
    this.$parent.containerMapLoading = true;
    this.info = JSON.parse(localStorage.getItem('info'));
    this.mapLocalData = JSON.parse(localStorage.getItem('userInfo_ZHXM'));
    that.$nextTick(() => {
      that.getYanmo(this.mapLocalData.mapAppAreasName);
      that.mapList();
      that.num++;
    });
  },
  methods: {
    changezcpd(val) {
      if (val) {
        this.checkInfo.createTime = val;
        this.checkCount(this.checkInfo);
      }
    },
    clickType(val) {
      this.divLoading = val;
      this.num++;
      if (!val) {
        this.checkInfo.deviceId = this.item.deviceId;
        this.checkCount(this.checkInfo);
      }
    },
    // 今日盘点
    checkCount(checkInfo) {
      getDeviceCheckCount(checkInfo).then(res => {
        if (res.data.data.records.length > 0) {
          this.checkList = res.data.data.records;
          this.checkList.forEach(item => {
            item.createTime = item.createTime.substring(11, item.createTime.length);
          });
          if (this.checkList.length > 0) {
            this.zcIndex = 0;
            this.zcCount = this.checkList[0].checkMaxCount;
            this.zcItemImg = this.checkList[0].checkImg;
          }
        } else {
          this.checkList = [];
        }
      });
    },
    zcClick(item, index) {
      this.zcItemImg = item.checkImg;
      this.zcIndex = index;
    },
    handlePreview() {
      this.$refs.preview.clickHandler();
    },
    previewSrclist(url) {
      var list = [];
      list.push(url);
      return list;
    },
    // 掩模
    getYanmo(mapAppAreasName) {
      var that = this;
      AMapLoader.reset();
      AMapLoader.load({
        key: '9447b0a8da9836b222021b63f32fc936', // 申请好的Web端开发者Key，首次调用 load 时必填
        version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ['AMap.DistrictSearch'] // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then(AMap => {
          this.AMap = AMap;

          let levelLabel = 'city';
          switch (Number(that.mapLocalData.areaLevel)) {
            case 1:
              levelLabel = 'province';
              break;
            case 2:
              levelLabel = 'city';
              break;
            case 3:
              levelLabel = 'district';
              break;
            default:
              break;
          }

          // 加载行政区插件
          if (!this.districtMap) {
            let opts = {
              subdistrict: 0,
              extensions: 'all',
              level: levelLabel // province, city, district
            };
            that.districtMap = new AMap.DistrictSearch(opts);
          }

          that.districtMap.search(
            mapAppAreasName,
            function (status, result) {
              var bounds = result.districtList[0].boundaries;
              var mask = [];
              for (var i = 0; i < bounds.length; i += 1) {
                mask.push([bounds[i]]);
              }
              that.map = new AMap.Map('container', {
                mask: mask,
                center: that.mapLocalData.mapAppAreasPoints.split(','),
                viewMode: '3D',
                showLabel: false,
                labelzIndex: 130,
                pitch: 40,
                mapStyle: 'amap://styles/grey',
                zoom: that.mapLocalData.mapAppAreasZoom,
                zooms: that.mapLocalData.mapAppAreasZooms,
                layers: [
                  new AMap.TileLayer.RoadNet({
                    //rejectMapMask:true
                  }),
                  new AMap.TileLayer.Satellite()
                ]
              });
              // that.addMap(that.formList, that.map, that.markers);
              //添加描边12
              for (var i = 0; i < bounds.length; i += 1) {
                new AMap.Polyline({
                  path: bounds[i],
                  strokeColor: '#3A77F1',
                  strokeWeight: 6,
                  map: that.map
                });
              }
              setTimeout(() => {
                that.$parent.containerMapLoading = false;
              }, 500);
            },
            function (err) {
              console.log(err, 'errr12');
            }
          );
          this.num++;
        })
        .catch(e => {
          console.log(e);
        });
    },
    addMap(data, map, markers) {
      if (data && data.length > 0) {
        data.forEach((item, index) => {
          // 创建点实例
          var marker = new AMap.Marker({
            position: new AMap.LngLat(item.addressLng, item.addressLat),
            icon: 'http://files.xiaomuding.com/images/20230609/fa46f51875fc432c894f9691bd3e59fe_70_82.png',
            offset: new AMap.Pixel(-35, -71),
            zIndex: '5'
          });
          // if (item.deviceStatus == 0) {
          //   var marker = new AMap.Marker({
          //     position: new AMap.LngLat(item.addressLng, item.addressLat),
          //     icon: 'http://files.xiaomuding.com/images/20230609/fa46f51875fc432c894f9691bd3e59fe_70_82.png',
          //     offset: new AMap.Pixel(-35, -71),
          //     zIndex: '5'
          //   });
          // } else {
          //   var marker = new AMap.Marker({
          //     position: new AMap.LngLat(item.addressLng, item.addressLat),
          //     icon: 'http://files.xiaomuding.com/images/20230609/57e33a09a1cf46e3894d0786913cc577_70_82.png',
          //     offset: new AMap.Pixel(-35, -71),
          //     zIndex: '1'
          //   });
          // }

          markers.push(marker);

          marker.on('click', e => {
            if (item.deviceImgUrl) {
              item.html =
                '<video class="video video-js vjs-big-play-centered  vjs-default-skin" style="object-fit: cover; width: 100%;height: 100%;" id=' +
                `mapVideo${item.deviceId}` +
                ' poster=' +
                `${item.deviceImgUrl}` +
                ' muted ></video>';
            } else {
              item.html =
                '<video class="video video-js vjs-big-play-centered  vjs-default-skin" style="object-fit: cover; width: 100%;height: 100%;" id=' +
                `mapVideo${item.deviceId}` +
                ' poster=' +
                'https://weimuyun-h5.oss-cn-hangzhou.aliyuncs.com/images/imgError.png' +
                ' muted ></video>';
              item.deviceImgUrl = `https://weimuyun-h5.oss-cn-hangzhou.aliyuncs.com/images/imgError.png`;
            }
            item.index = index;
            item.play_status = false;
            this.item = item;
            this.loading = true;
            this.$emit('mapCallBank', this.loading);
          });
          // 使用方式
          marker.on('mousemove', e => {
            // marker.setPosition(e.lnglat);
            marker.setLabel({
              offset: new AMap.Pixel(0, 15), //设置文本标注偏移量
              content: '<div class="allover">' + item.farmName + '</div>', //设置文本标注内容
              direction: 'top' //设置文本标注方位
            });
          });
          marker.on('mouseout', e => {
            marker.setLabel({
              offset: new AMap.Pixel(0, 20), //设置文本标注偏移量
              content: '', //设置文本标注内容
              direction: 'top' //设置文本标注方位
            });
          });

          setTimeout(() => {
            if (map) map.add(markers);
          }, 200);
        });
      }
    },
    mapList() {
      getFarmMapList({
        current: 1,
        size: 1000,
        areaId: this.mapLocalData.authProvincesCityAreas,
        applicationDeptId: JSON.parse(localStorage.getItem('itemInfo')).applicationDeptId,
        applicationId: JSON.parse(localStorage.getItem('itemInfo')).applicationId,
        livestockType: JSON.parse(localStorage.getItem('itemInfo')).livestockType
      }).then(res => {
        this.formList = res.data.data.records;
        this.addMap(this.formList, this.map, this.markers);
      });
    },
    clickClose(item) {
      this.loading = false;
      this.openLoading = true;
      this.divLoading = true;
      if (item.player) {
        item.player.dispose();
      }
      this.$emit('mapCallBank', this.loading);
    },
    playBack(item) {
      if (!item.play_status) {
        this.$set(item, 'videoSrc', item.deviceId);
        item.type = true;
        item.play_status = true;
        item.width = '560px';
        item.height = '320px';
        this.openLoading = false;
      }
    },
    getVideo(index, id, nowPlayVideoUrl) {
      this.$set(this.formList[index], 'player', videojs(id, this.videoOptions));
      //关键代码， 动态设置src，才可实现换台操作
      this.formList[index].player.src([
        {
          src: nowPlayVideoUrl,
          type: 'application/x-mpegURL' // 告诉videojs,这是一个hls流
        }
      ]);
      this.videoIndex = index;
      this.formList[index].player.on('fullscreenchange', this.handleFullScreenChange);
    },
    handleFullScreenChange() {
      if (this.formList[this.videoIndex].player.isFullscreen()) {
        // 进入全屏
        console.log('进入全屏');
        this.$emit('change', true);
      } else {
        // 退出全屏
        console.log('退出全屏');
        this.$emit('change', false);
      }
    }
  }
};
</script>
<style scoped lang="scss">
* {
  margin: 0;
  padding: 0;
}
/deep/ .el-picker-panel .el-date-picker .el-popper {
  background: red;
}
.pasture-box {
  width: 120px;
  height: 180px;
  border-right: 1px solid #868686;
  margin-top: 10px;
  div {
    line-height: 30px;
    height: 30px;
    width: 84px;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    background: url('./img/type-text.png') no-repeat;
    margin-left: 20px;
  }

  .divAcive {
    font-size: 16px;
    line-height: 30px;
    height: 30px;
    height: 30px;
    width: 84px;
    background: url('./img/typeActive.png') no-repeat;
  }
}
.ssets {
  margin-top: 10px;
  margin-left: 20px;
  &-ul {
    height: 140px;
    overflow-y: scroll;
    li {
      line-height: 28px;
      display: flex;
      cursor: pointer;
    }
    .liActive {
      color: #e7ca4c;
    }
  }
}
.ssets-count {
  width: 264px;
  text-align: right;
  padding-top: 10px;
}
::-webkit-scrollbar {
  display: none;
}
/deep/ #container .amap-marker-label {
  position: absolute;
  z-index: 2;
  background: url('./img/label.png');
  background-size: 100% 100%;
  cursor: default;
  font-size: 14px;
  line-height: 14px;
  color: #fff;
  line-height: 20px;
  padding: 10px;
  border: none;
  height: 44px;
}
/deep/ .el-input--prefix .el-input__inner {
  width: 170px;
  height: 30px;
  line-height: 30px;
  background: url('./img/input-bg.png') no-repeat;
  background: 100% 100%;
  position: relative;
  color: #fff;
  border: 1px solid #1d5fd1;
}
/deep/ .el-input__icon {
  // position: absolute;
  // right: 0;
  // top: 0;
  line-height: 30px;
}

.box {
  width: 100%;
  height: 100%;
  color: #fff;
}
#container {
  width: 100%;
  height: 100%;
  position: relative;
}

.pasture {
  width: 600px;
  background: linear-gradient(180deg, #0e213e 0%, #10141b 100%);
  padding-bottom: 25px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -300px;
  margin-top: -300px;
  // transform: translate(-50%, -50%);
  border: 1px solid #1d5fd1;
  z-index: 4000;
}

.pasture-title {
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: linear-gradient(94deg, rgba(22, 95, 203, 0) 4%, #165fcb 52%, rgba(22, 95, 203, 0) 100%);
  opacity: 1;
  position: relative;
}

.pasture-exit {
  width: 24px;
  height: 24px;
  background: url('./img/exit.png');
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
}

.iframe {
  width: 356px;
  height: 200px;
  background: #000;
  opacity: 1;
  margin-left: 20px;
  margin-top: 20px;
}

.pasture-name {
  height: 24px;
  font-size: 18px;
  font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
  font-weight: 500;
  line-height: 24px;
  padding-top: 10px;
  padding-left: 20px;
  padding-right: 70px;
  position: relative;
  overflow: hidden;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pasture-name-breed {
  width: 50px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background: url('./img/breed.png');
  background-size: 100% 100%;
  position: absolute;
  right: 20px;
  top: 4px;
  font-size: 14px;
  z-index: 11;
}

.pasture-address {
  height: 17px;
  font-size: 14px;
  font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
  font-weight: 400;
  line-height: 17px;
  padding-left: 35px;
  padding-top: 20px;
  position: relative;
}

.pasture-icon {
  height: 12px;
  width: 12px;
  display: inline-block;
  background: url('./img/pasrtrue-icon.png');
  position: absolute;
  left: 20px;
  top: 23px;
}

.pasture-user {
  display: flex;
  font-size: 14px;
  padding-left: 20px;
  padding-top: 5px;
  height: 17px;
  font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
  font-weight: 400;
  line-height: 17px;
  color: #888;
}

/* style="" */
.pl8 {
  padding-left: 10px;
}

.pl20 {
  padding-left: 20px;
}

.white {
  color: white;
}

.pasture-data {
  display: flex;
  margin-top: 20px;
  padding: 0 20px;
  height: 42px;
}

.pasture-data div {
  flex: 1;
  /* border-right: 1px solid #868686; */
  box-sizing: border-box;
}

.pasture-data p {
  flex: 1;
  height: 17px;
  font-size: 14px;
  font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
  font-weight: 400;
  /* color: #FFFFFF; */
  line-height: 17px;
}

.center {
  text-align: center;
}

.pasture-number {
  font-weight: 500;
  font-size: 20px !important;
  margin-top: 15px;
  color: #1d5fd1;
}

.pasture-number span {
  font-weight: 400;
  font-size: 14px !important;
  color: #fff;
}

.iframes {
  margin-top: 14px;
  margin-left: 20px;
  position: relative;
}

.iframes span {
  height: 50px;
  width: 50px;
  display: inline-block;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -40px;
  margin-top: -30px;
  background: url('./img/open.png');
}

.alert {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.pastureBack {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  // background: rgba(0, 0, 0, 0.65);
  z-index: 4500;
  box-sizing: border-box;
}

/deep/ .amap-logo {
  display: none !important;
}

/deep/ .amap-copyright {
  display: none !important;
}

/deep/ .amap-container {
  background: none !important;
}
/deep/ .vjs-icon-fullscreen-exit {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/SmartLivestock/statistics/map/newMap.vue